export enum SessionState {
  Started,
  TxActive,
  TxStopped,
  Validating,
  Suspicious,
  Approved,
  Rejected,
  PendingRerate,
  Rerating,
  CdrPublished,
  PendingAggregation,
  PendingUndoAggregation,
  AggregationFailed,
  Aggregated,
  CdrCreationFailed,
  Invalid
}
